<div class="one" fxLayout="column" [formGroup]="matterAddressForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Search for Address</mat-label>
      <input
        type="text"
        id="addressInput"
        name="ADDRESS1"
        formControlName="ADDRESS1"
        matInput
        placeholder="Start typing to search for an address"
        #addressInput
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <!-- (click)="setAutoField(option ,1)" -->
        @for (option of searchData; track option; let i = $index) {
          <mat-option [value]="option.COMBINED" (onSelectionChange)="setAutoField(option, 1)">
            {{ option.COMBINED }}
          </mat-option>
        }
      </mat-autocomplete>
      <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ADDRESS1?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.ADDRESS1?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BUILDINGNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BUILDINGNAME),
      }"
    >
      <mat-label>Building Name</mat-label>
      <input matInput formControlName="BUILDINGNAME" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNITNUMBER),
      }"
    >
      <mat-label>Unit No.</mat-label>
      <input matInput name="Unit No" formControlName="UNITNUMBER" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNUMBER),
      }"
    >
      <mat-label>Street No</mat-label>
      <input matInput name="StreetNo" formControlName="STREETNUMBER" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="10"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNUMBERTO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNUMBERTO),
      }"
    >
      <mat-label>To</mat-label>
      <input matInput name="To" formControlName="STREETNUMBERTO" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="30"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETNAME),
      }"
    >
      <mat-label>Street</mat-label>
      <input name="Street" matInput formControlName="STREETNAME" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STREETTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STREETTYPE),
      }"
    >
      <mat-label>Street Type</mat-label>
      <input
        type="text"
        placeholder="State"
        aria-label="Number"
        matInput
        name="STREETTYPE"
        formControlName="STREETTYPE"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete">
        @for (val of StreetType; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="30"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SUBURB),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SUBURB),
      }"
    >
      <mat-label>Suburb</mat-label>
      <input matInput name="Suburb" formControlName="SUBURB" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STATE),
      }"
    >
      <mat-label>State</mat-label>
      <input
        type="text"
        placeholder="State"
        aria-label="Number"
        matInput
        name="STATE"
        formControlName="STATE"
        [matAutocomplete]="auto3"
      />
      <mat-autocomplete #auto3="matAutocomplete">
        @for (val of StateData; track val) {
          <mat-option value="{{ val.LOOKUPFULLVALUE }}">
            {{ val.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.POSTCODE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.POSTCODE),
      }"
    >
      <mat-label>Post Code</mat-label>
      <input matInput name="PostCode" formControlName="POSTCODE" />
    </mat-form-field>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
    [ngClass]="{
      'has-error': $safeNavigationMigration(errorWarningData.Error?.NATUREOFBUILDING),
      'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NATUREOFBUILDING),
    }"
  >
    <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
      <mat-label>Nature Of Building</mat-label>
      <input matInput name="NatureOfBulding" formControlName="NATUREOFBUILDING" />
    </mat-form-field>
  </div>
</div>
